import styled from 'styled-components';

import { TextAreaWrapper } from '~/components/chat/chat-input/chat-input-fields/ChatDocumentContextInput.styles';

export const AlfredFooterRoot = styled.footer<{ $paused?: boolean }>`
  position: sticky;
  bottom: 0;
  inset-inline: 0;
  z-index: 1;
  display: block;
  padding: 12px 20px 12px;
  background-color: var(--background-soft);
  --gradient-bar-play-state: ${({ $paused }) =>
    $paused ? 'paused' : 'running'};

  &:hover {
    --gradient-bar-play-state: paused;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const LeftControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  grid-column: 1;
  margin-right: 4px;
`;

export const InputRegion = styled.div<{ $isPinned?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: 2;
  min-width: 300px;
  --chat-message-width: 1000px;

  ${TextAreaWrapper} {
    padding: 8px 12px ${({ $isPinned }) => ($isPinned ? '40px' : '8px')};
  }
`;
